import styled from 'styled-components'

export const StyledContact = styled.div``
